<template>
  <admin-page-frame>
    <school-list-toolbar @search="loadList" @reset="handleReset">
      <template #actions>
        <el-button class="filter-item" type="primary" size="mini" icon="el-icon-plus" @click="openForm()">新增</el-button>
      </template>
      <template #filters>
        <el-input
          v-model="query.keyword"
          clearable
          size="small"
          placeholder="科目名称/编码"
          class="filter-item"
          style="width: 200px; margin-right: 10px;"
          @keyup.enter.native="loadList"
        />
        <el-select
          v-model="query.status"
          clearable
          size="small"
          placeholder="状态"
          class="filter-item"
          style="width: 130px; margin-right: 10px;"
        >
          <el-option label="启用" :value="1" />
          <el-option label="停用" :value="0" />
        </el-select>
      </template>
    </school-list-toolbar>

    <el-table v-loading="loading" :data="list" :border="false" size="small" style="width: 100%;">
      <el-table-column prop="subjectCode" label="科目编码" min-width="120" show-overflow-tooltip />
      <el-table-column prop="subjectName" label="科目名称" min-width="120" show-overflow-tooltip />
      <el-table-column prop="sortNo" label="排序" width="80" align="center" />
      <el-table-column prop="status" label="状态" width="80" align="center">
        <template slot-scope="{ row }">
          <el-tag :type="row.status === 1 ? 'success' : 'info'" size="mini">{{ row.status === 1 ? '启用' : '停用' }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="创建时间" width="160" />
      <el-table-column label="操作" min-width="120" width="120" align="center" fixed="right" class-name="admin-pc-table-actions-col">
        <template slot-scope="{ row }">
          <div class="admin-pc-table-actions">
            <el-button type="text" size="mini" @click="openForm(row)">编辑</el-button>
            <el-button type="text" size="mini" class="admin-pc-table-actions__danger" @click="handleDelete(row)">删除</el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <school-list-pagination
      :total="total"
      :page="query.page"
      :size="query.size"
      @page-change="onPageChange"
      @size-change="onSizeChange"
    />

    <el-dialog :title="form.id ? '编辑科目' : '新增科目'" :visible.sync="formVisible" width="480px" :close-on-click-modal="false" @closed="resetForm">
      <el-form ref="formRef" :model="form" :rules="formRules" label-width="90px" size="small" class="admin-pc-dialog-form">
        <el-form-item v-if="form.id" label="科目编码">
          <el-input v-model="form.subjectCode" disabled />
        </el-form-item>
        <p v-else class="admin-pc-form-hint">科目编码将在保存后自动生成</p>
        <el-form-item label="科目名称" prop="subjectName">
          <el-input v-model="form.subjectName" maxlength="64" />
        </el-form-item>
        <el-form-item label="排序">
          <el-input-number v-model="form.sortNo" :min="0" :max="9999" />
        </el-form-item>
        <el-form-item label="状态">
          <el-radio-group v-model="form.status">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="0">停用</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="formVisible = false">取消</el-button>
        <el-button type="primary" size="small" :loading="saving" @click="submitForm">保存</el-button>
      </div>
    </el-dialog>
  </admin-page-frame>
</template>

<script>
import AdminPageFrame from './components/AdminPageFrame.vue'
import SchoolListToolbar from './components/SchoolListToolbar.vue'
import SchoolListPagination from './components/SchoolListPagination.vue'
import schoolListPageMixin from './mixins/school-list-page'
import { fetchSchoolSubjects, saveSchoolSubject, updateSchoolSubject, deleteSchoolSubject } from '@/api/h5-admin-schools'
import './schools-admin.less'

const DEFAULT_QUERY = { keyword: '', status: null, page: 0, size: 20 }

export default {
  name: 'SchoolsSubject',
  components: { AdminPageFrame, SchoolListToolbar, SchoolListPagination },
  mixins: [schoolListPageMixin],
  data() {
    return {
      loading: false,
      saving: false,
      list: [],
      total: 0,
      query: { ...DEFAULT_QUERY },
      formVisible: false,
      form: { id: null, subjectCode: '', subjectName: '', sortNo: 0, status: 1 },
      formRules: {
        subjectName: [{ required: true, message: '请输入科目名称', trigger: 'blur' }]
      }
    }
  },
  created() {
    this.loadList()
  },
  methods: {
    handleReset() {
      this.resetListQuery(DEFAULT_QUERY)
    },
    loadList() {
      this.loading = true
      fetchSchoolSubjects(this.query)
        .then(res => {
          this.list = (res && res.content) || []
          this.total = (res && res.totalElements) || 0
        })
        .finally(() => { this.loading = false })
    },
    openForm(row) {
      if (row) {
        this.form = {
          id: row.id,
          subjectCode: row.subjectCode,
          subjectName: row.subjectName,
          sortNo: row.sortNo || 0,
          status: row.status != null ? row.status : 1
        }
      } else {
        this.resetForm()
      }
      this.formVisible = true
    },
    resetForm() {
      this.form = { id: null, subjectCode: '', subjectName: '', sortNo: 0, status: 1 }
      this.$nextTick(() => this.$refs.formRef && this.$refs.formRef.clearValidate())
    },
    submitForm() {
      this.$refs.formRef.validate(valid => {
        if (!valid) return
        this.saving = true
        const req = this.form.id
          ? updateSchoolSubject(this.form.id, this.form)
          : saveSchoolSubject(this.form)
        req.then(() => {
          this.$message.success('保存成功')
          this.formVisible = false
          this.loadList()
        }).finally(() => { this.saving = false })
      })
    },
    handleDelete(row) {
      this.$confirm('确定删除该科目吗？', '提示', { type: 'warning' }).then(() => {
        deleteSchoolSubject(row.id).then(() => {
          this.$message.success('已删除')
          this.loadList()
        })
      }).catch(() => {})
    }
  }
}
</script>
